export const SEOMATIC_QUERY = `
query getSeomatic(
  $site: String
  $uri: String) {
  
  seomatic(site: $site, uri: $uri) {
    metaTagContainer
    metaTitleContainer
    metaScriptContainer
    metaLinkContainer
  }
}
`